"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _parseISO = _interopRequireDefault(require("date-fns/parseISO"));

var _startOfWeek = _interopRequireDefault(require("date-fns/startOfWeek"));

var _endOfWeek = _interopRequireDefault(require("date-fns/endOfWeek"));

var _startOfMonth = _interopRequireDefault(require("date-fns/startOfMonth"));

var _endOfMonth = _interopRequireDefault(require("date-fns/endOfMonth"));

var _format = _interopRequireDefault(require("date-fns/format"));

var _addHours = _interopRequireDefault(require("date-fns/addHours"));

var _addDays = _interopRequireDefault(require("date-fns/addDays"));

var _addWeeks = _interopRequireDefault(require("date-fns/addWeeks"));

var _addMonths = _interopRequireDefault(require("date-fns/addMonths"));

var _addYears = _interopRequireDefault(require("date-fns/addYears"));

var _chevronLeftSmall = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/chevron-left-small"));

var _chevronDoubleLeft = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/chevron-double-left"));

var _chevronRightSmall = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/chevron-right-small"));

var _chevronDoubleRight = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/chevron-double-right"));

var _button = _interopRequireDefault(require("../button"));

var _icon = _interopRequireDefault(require("../icon"));

var _dateTime = _interopRequireDefault(require("../date-time"));

var _theme = require("../theme");

var _text = _interopRequireDefault(require("./../_styles/text"));

var _visuallyHidden = _interopRequireDefault(require("./../_styles/visually-hidden"));

var _dateString = require("./../_utils/date-string");

var _dateLocales = _interopRequireWildcard(require("./../_utils/date-locales"));

var _intlDateTimeFormat = require("./../_utils/intl-date-time-format");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var hourFormat = {
  day: "numeric",
  month: "short",
  year: "numeric",
  hour: "numeric"
};
var dayFormat = {
  day: "numeric",
  month: "short",
  year: "numeric"
};
var monthFormat = {
  month: "long",
  year: "numeric"
};

var styles = function styles(t) {
  return (0, _emotion.css)((0, _text["default"])(t), {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    fontSize: 20,
    fontWeight: 600,
    "& > *:not(button)": {
      margin: "0 16px"
    },
    "& > [aria-current='true']": _visuallyHidden["default"]
  });
};

var shouldNotUpdate = function shouldNotUpdate(prevProps, nextProps) {
  return prevProps.value === nextProps.value && prevProps.type === nextProps.type && prevProps.locale === nextProps.locale;
};
/**
 * Return the first date of the given date's timeframe.
 */


var startOf = function startOf(date, type, locale) {
  switch (type) {
    // For hour and day, the start day is the current day
    case "hour":
      return date;

    case "day":
      return date;

    case "week":
      return (0, _startOfWeek["default"])(date, {
        weekStartsOn: (0, _dateLocales.getDateLocale)(locale).weekStart
      });

    case "month":
      return (0, _startOfMonth["default"])(date);
  }
};
/**
 * Return the last date of the given date's timeframe.
 */


var endOf = function endOf(date, type, locale) {
  switch (type) {
    // For hour and day, the last day is the current day
    case "hour":
      return date;

    case "day":
      return date;

    case "week":
      return (0, _endOfWeek["default"])(date, {
        weekStartsOn: (0, _dateLocales.getDateLocale)(locale).weekStart
      });

    case "month":
      return (0, _endOfMonth["default"])(date);
  }
};
/**
 * Add days/weeks/months/years to a given date.
 */


var add = function add(date, type, amount) {
  switch (type) {
    case "hour":
      return (0, _addHours["default"])(date, amount);

    case "day":
      return (0, _addDays["default"])(date, amount);

    case "week":
      return (0, _addWeeks["default"])(date, amount);

    case "month":
      return (0, _addMonths["default"])(date, amount);

    case "year":
      return (0, _addYears["default"])(date, amount);
  }
};
/**
 * This component renders a control that can be used to select the visible
 * timeframe for a calendar.
 *
 * @since 5.x
 */


var CalendarTimeframeSelect = /*#__PURE__*/_react["default"].memo(function (props) {
  var t = (0, _theme.useTheme)();
  var value = props.value,
      type = props.type,
      locale = props.locale,
      onChange = props.onChange;
  var date = (0, _react.useMemo)(function () {
    return startOf((0, _parseISO["default"])(value), type, locale);
  }, [value, type, locale]);
  var skipType = type === "hour" ? "day" : type === "day" ? "week" : type === "week" ? "month" : "year";
  var onChangeDate = (0, _react.useCallback)(function (date) {
    return onChange(type === "hour" ? (0, _format["default"])(startOf(date, type, locale), "yyyy-MM-dd HH:mm") : (0, _dateString.toDateString)(startOf(date, type, locale)), type === "hour" ? (0, _format["default"])(endOf(date, type, locale), "yyyy-MM-dd HH:mm") : (0, _dateString.toDateString)(endOf(date, type, locale)));
  }, [onChange, type, locale]);
  var getFormattedDate = (0, _react.useCallback)(function (date) {
    if (type === "week") {
      var _intlDateTimeRangeFor = (0, _intlDateTimeFormat.intlDateTimeRangeFormat)(startOf(date, type, props.locale), endOf(date, type, props.locale), dayFormat, props.locale),
          _intlDateTimeRangeFor2 = (0, _slicedToArray2["default"])(_intlDateTimeRangeFor, 2),
          start = _intlDateTimeRangeFor2[0],
          end = _intlDateTimeRangeFor2[1];

      return "".concat(start, " - ").concat(end);
    } else {
      return (0, _intlDateTimeFormat.intlDateTimeFormat)(date, type === "month" ? monthFormat : type === "day" ? dayFormat : hourFormat, props.locale);
    }
  }, [type, props.locale]);
  var currentLabel = (0, _react.useMemo)(function () {
    return getFormattedDate(date);
  }, [getFormattedDate, date]);
  var previousSkipLabel = (0, _react.useMemo)(function () {
    if (!props.showSkipButtons) return "";
    var previousSkipDate = getFormattedDate(add(date, skipType, -1));
    return props.previousSkipLabel ? "".concat(props.previousSkipLabel, ", ").concat(previousSkipDate) : "Previous ".concat(skipType, ", ").concat(previousSkipDate);
  }, [getFormattedDate, props.showSkipButtons, props.previousSkipLabel, date, skipType]);
  var previousLabel = (0, _react.useMemo)(function () {
    var previousDate = getFormattedDate(add(date, type, -1));
    return props.previousLabel ? "".concat(props.previousLabel, ", ").concat(previousDate) : "Previous ".concat(type, ", ").concat(previousDate);
  }, [getFormattedDate, props.previousLabel, type, date]);
  var nextLabel = (0, _react.useMemo)(function () {
    var nextDate = getFormattedDate(add(date, type, 1));
    return props.nextLabel ? "".concat(props.nextLabel, ", ").concat(nextDate) : "Next ".concat(type, ", ").concat(nextDate);
  }, [getFormattedDate, props.nextLabel, type, date]);
  var nextSkipLabel = (0, _react.useMemo)(function () {
    var nextDate = getFormattedDate(add(date, skipType, 1));
    return props.nextSkipLabel ? "".concat(props.nextSkipLabel, ", ").concat(nextDate) : "Next ".concat(skipType, ", ").concat(nextDate);
  }, [getFormattedDate, props.nextSkipLabel, skipType, date]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles(t)
  }, props.showSkipButtons ? /*#__PURE__*/_react["default"].createElement(_button["default"], {
    type: "icon",
    onClick: function onClick() {
      return onChangeDate(add(date, skipType, -1));
    },
    label: previousSkipLabel
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _chevronDoubleLeft["default"]
  })) : null, /*#__PURE__*/_react["default"].createElement(_button["default"], {
    type: "icon",
    onClick: function onClick() {
      return onChangeDate(add(date, type, -1));
    },
    label: previousLabel,
    disabled: props.previousDisabled
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _chevronLeftSmall["default"]
  })), /*#__PURE__*/_react["default"].createElement("span", {
    "aria-live": "polite",
    "aria-current": "true"
  }, currentLabel), /*#__PURE__*/_react["default"].createElement("span", {
    "aria-hidden": "true"
  }, /*#__PURE__*/_react["default"].createElement(_dateTime["default"], {
    dateTime: (0, _dateString.toDateString)(startOf(date, type, locale)),
    endDateTime: type === "week" ? (0, _dateString.toDateString)(endOf(date, type, locale)) : undefined,
    format: type === "month" ? monthFormat : dayFormat,
    locale: locale
  })), /*#__PURE__*/_react["default"].createElement(_button["default"], {
    type: "icon",
    onClick: function onClick() {
      return onChangeDate(add(date, type, 1));
    },
    label: nextLabel,
    disabled: props.nextDisabled
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _chevronRightSmall["default"]
  })), props.showSkipButtons ? /*#__PURE__*/_react["default"].createElement(_button["default"], {
    type: "icon",
    onClick: function onClick() {
      return onChangeDate(add(date, skipType, 1));
    },
    label: nextSkipLabel
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _chevronDoubleRight["default"]
  })) : null);
}, shouldNotUpdate);

CalendarTimeframeSelect.displayName = "CalendarTimeframeSelect";
CalendarTimeframeSelect.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The size of the timeframe being selected.
   */
  type: _propTypes["default"].oneOf(["hour", "day", "week", "month"]).isRequired,

  /**
   * Any date in an ISO 8601 format (e.g. YYYY-MM-DD) within the day/week/month that should be
   * selected.
   */
  value: _propTypes["default"].string.isRequired,

  /**
   * A function that will be called when the user attempts to change the value
   * of the component (e.g. by clicking the next week/month button). Two
   * arguments will be passed to this function -  the first and last dates of
   * the selected timeframe. Note that only one of these dates has to be passed
   * back to the `value` prop (see below). If you need both dates for your app
   * logic you can grab both of them, otherwise you can just forget the second
   * argument and use the first.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the value passed to this function somewhere in state
   * and pass it back via the `value` prop in order to make this component
   * interactive. Because this component accepts any date within a timeframe
   * you can pass back just one of the dates provided to the onChange function.
   */
  onChange: _propTypes["default"].func.isRequired,

  /**
   * The locale to use when rendering the selected month. See the [Intl API](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl)
   * for more information about date internationalization in JS.
   */
  locale: _propTypes["default"].oneOf(Object.keys(_dateLocales["default"])),

  /**
   * This disables interaction with the button that selects the next week/month
   * and applies special visual styles to indicate that it's not interactive.
   *
   * @since 5.23.0
   */
  nextDisabled: _propTypes["default"].bool,

  /**
   * A localized label for the button that selects the next week/month. Defaults
   * to "Next hour|day|week|month" (depending on `type`).
   *
   * The next hour/day/week/month will be appended. If, for example, the current
   * month is October 2021 and `nextLabel="Go to the next month"` the final label
   * will be "Go to the next month, November 2021".
   */
  nextLabel: _propTypes["default"].string,

  /**
   * A localized label for the button that skips to the next month/year.
   * Defaults to "Next day|week|month|year" (depending on `type`).
   *
   * The skip hour/day/week/month will be appended. If, for example, the current
   * month is October 2021 and `nextSkipLabel="Go to the next year"` the final
   * label will be "Go to the next year, October 2022".
   */
  nextSkipLabel: _propTypes["default"].string,

  /**
   * This disables interaction with the button that selects the previous week/month
   * and applies special visual styles to indicate that it's not interactive.
   *
   * @since 5.23.0
   */
  previousDisabled: _propTypes["default"].bool,

  /**
   * A localized label for the button that selects the previous week/month.
   * Defaults to "Previous hour|day|week|month" (depending on `type`).
   *
   * The previous hour/day/week/month will be appended. If, for example, the current
   * month is October 2021 and `previousLabel="Go to the previous month"` the
   * final label will be "Go to the previous month, September 2021".
   */
  previousLabel: _propTypes["default"].string,

  /**
   * A localized label for the button that skips to the previous month/year.
   * Defaults to "Previous day|week|month|year" (depending on `type`).
   *
   * The skip hour/day/week/month will be appended. If, for example, the current
   * month is October 2021 and `previousSkipLabel="Go to the previous year"` the
   * final label will be "Go to the previous year, October 2020".
   */
  previousSkipLabel: _propTypes["default"].string,

  /**
   * Set to false to hide the skip buttons.
   */
  showSkipButtons: _propTypes["default"].bool
} : {};
CalendarTimeframeSelect.defaultProps = {
  locale: "en-US",
  showSkipButtons: true
};
var _default = CalendarTimeframeSelect;
exports["default"] = _default;